<template>
    <div class="post-detail" v-if="detail" v-title="detail.Title">
        <div class="head">
            <div class="head-logo">
                <img src="@/assets/login/sp_logo.png" alt="LOGO">
            </div>
            <div class="head-btn">
                <button @click="uploadApp">下载APP</button>
                <i v-if="!userData">|</i>
                <button v-if="!userData">
                    <router-link to="/login/personLogin" class="link">注册登录</router-link>
                </button>
            </div>
        </div>
        <div class="post-content">
            <h3 class="post-title">{{detail.Title}}</h3>
            <div class="post-user">
                <div class="user-portrait">
                    <div>
                        <img :src="detail.HeaderImgUrl" alt="头像">
                    </div>
                    <img v-if="detail.IsBpoOfficial" class="bv" src="@/assets/new/bv.png" alt="图标">
                </div>
                <div class="user-info">
                    <h3 class="user-title">{{detail.UserName}}</h3>
                    <img v-if="detail.IsBpoMember" src="@/assets/new/vip.png"
                        style="width:20px;height:16px;margin-right: 6px;" alt="vip">
                    <img v-if="detail.IsExpert" src="@/assets/new/master.png" style="width:24px;height:14px;" alt="大咖">
                </div>
            </div>
            <div class="content" v-html="detail.Content"></div>
            <div class="issue-time">发布于{{detail.CreateTime}}·著作权归作者所有</div>
        </div>
        <div style="height: 10px;background: #f9f9f9;font-size: 0;">分割线</div>
        <div class="comment-mian">
            <div class="contentNum-actions">
                <div class="comment-num">评论<span>{{detail.CommentCount}}</span></div>
                <div class="comment-switch">
                    <span class="on" @click="openAPP">热度</span>
                    <span class="new" @click="openAPP">最新</span>
                </div>
            </div>
            <div class="comment-content-box">
                <ul class="comment-content-list">
                    <li class="comment-item" v-for="(item,index) in commentList" :key="index">
                        <div class="item-user-portrait" @click="openAPP">
                            <img :src="item.HeadImgUrl" alt="头像" />
                        </div>
                        <div class="item-user-info">
                            <h4>{{item.UserName}}<span v-if="item.IsAuthor" class="me">作者</span></h4>
                        </div>
                        <template v-if="!item.IsDelete" >
                            <p class="item-test" v-html="renderTxt(item.Content)" @click="openAPP"></p>
                            <div class="item-img-list" @click="openAPP" v-if="item.ImgList && item.ImgList.length">
                                <div class="item-img-item" v-for="(img,idx) in item.ImgList" :key="idx">
                                    <img :src="img" :preview="index" alt="图片">
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <p class="item-test">该评论已删除</p>
                        </template>
                        <div class="new-operation-btn" style="margin-top: 15px;">
                            <span class="issue-time" style="color: #666666;">{{item.CreateTime}}<span
                                    v-if="item.IsAuthorReply"> · 作者回复了</span></span>
                            <div class="operation-btn" v-if="!item.IsDelete">
                                <span class="dz" @click="openAPP">{{item.ThumbUpCount}}</span>
                                <span class="pl icon-comment" @click="openAPP">0</span>
                            </div>
                        </div>
                        <div class="items-comment-content-box">
                            <el-collapse-transition>
                                <ul class="items-comment-content-list" v-show="item.showList"
                                    v-if="item.ChildCommentList">
                                    <li class="items-comment-item" v-for="(items,indexs) in item.ChildCommentList"
                                        :key="indexs">
                                        <div class="item-user-info">
                                            <div class="items-hf">
                                                <span>{{items.UserName}}</span><i>回复</i><span>{{items.ParentUserName}}</span>：
                                            </div>
                                        </div>
                                        <p class="items-item-test" v-html="renderTxt(items.Content)"></p>
                                        <div class="item-img-list" v-if="items.ImgList && items.ImgList.length">
                                            <div class="item-img-item" v-for="(img,idx) in items.ImgList" :key="idx">
                                                <img :src="img" :preview="index" alt="图片">
                                            </div>
                                        </div>
                                        <div class="new-operation-btn" style="margin-top: 15px;">
                                            <span class="issue-time" style="color: #666666;">{{items.CreateTime}}</span>
                                            <div class="operation-btn">
                                                <span class="dz">{{items.ThumbUpCount}}</span>
                                                <span class="pl icon-comment">0</span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </el-collapse-transition>
                            <div class="look-more" @click="openAPP" v-if="item.ChildCommentList && item.ChildCommentList.length">
                                <span>展开全部 <b>{{item.ChildCommentList.length}}</b> 条回复</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="footer-open-app-text">
            <button @click="openAPP">打开APP查看全部评论</button>
        </div>
        <div class="footer-open-app">
            <button @click="openAPP">APP内打开</button>
        </div>
        <div class="wx-mask" v-if="isShowWX" @click="isShowWX=false"></div>
    </div>
</template>
<script>
    let u = navigator.userAgent;
    let ua = navigator.userAgent.toLowerCase();
    // import bridge from '@/common/dsbridge.js';
    import {
        GetPostDetail, //帖子详情
        GetPostCommentList, //帖子评论
    } from '@/common/api.js'
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                detail: null,
                commentList: [], //评论列表
                pageNum: 1,
                pageSize: 2,

                isShowWX: false
            }
        },
        computed: {
            ...mapState({
                userData: state => state.userData,
                createConfig: state => state.createConfig,
            }),
        },
        created() {
            let that = this;
            that.GetPostDetailInfo();
            that.getPostCommentList();
        },
        activated() {

        },
        mounted() {

        },
        methods: {
            // 获取详情
            GetPostDetailInfo() {
                GetPostDetail({
                    PostId: this.$route.query.id,
                }).then(res => {
                    this.detail = res.Data
                })
            },
            // 获取评论
            getPostCommentList() {
                GetPostCommentList({
                    PostId: this.$route.query.id,
                    SortType: 1,
                    PageNum: this.pageNum,
                    PageSize: this.pageSize,
                }).then(res => {
                    this.commentList = res.Data.PostCommentList || [];
                })
            },
            //渲染表情图片
            customEmoji(value) {
                var html = '';
                var str = value.replace(/\[|]/g, '')
                html =
                    `<img src="https://gk-manager.oss-cn-zhangjiakou.aliyuncs.com/Emoji/${str}.png" style="width:30px"/>`
                return html;
            },
            //渲染消息文字和表情图片
            renderTxt(txt = "") {
                let rnTxt = [];
                let match = null;
                const regex = /(\[.*?\])/g;
                // const regex = /\[|]/g;
                let start = 0;
                let index = 0;
                while ((match = regex.exec(txt))) {
                    index = match.index;
                    if (index > start) {
                        rnTxt.push(txt.substring(start, index));
                    }
                    rnTxt.push(this.customEmoji(match[1]));
                    start = index + match[1].length;
                }
                rnTxt.push(txt.substring(start, txt.length));
                return rnTxt.join(''); //.replace(/,/g, "")
            },
            // 下载app
            uploadApp() {
                if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                    this.isShowWX = true;
                    return;
                }
                window.location.href = 'https://wx.insupai.com/download/download.html';
            },
            openAPP: function () {
                if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                    this.isShowWX = true;
                    return;
                }

                if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
                    console.log('安卓');
                    window.location.href =
                        `gongkongsupai://com.gongkong.supai?launchType=16&forumId=${this.$route.query.id}`;
                    clearTimeout(this.timer);
                    this.timer = setTimeout(() => {
                        window.location.href = 'https://wx.insupai.com/download/download.html';
                        clearTimeout(this.timer);
                    }, 3000);
                } else if (u.indexOf('iPhone') > -1) {
                    console.log('苹果');
                    window.location.href =
                        `gongkongsupai://param?launchType=16&forumId=${this.$route.query.id}`;
                    clearTimeout(this.timer);
                    this.timer = setTimeout(() => {
                        window.location.href = 'https://wx.insupai.com/download/download.html';
                        clearTimeout(this.timer);
                    }, 3000);
                }
            },
        }
    }
</script>
<style lang="scss">
    .post-detail {
        background: #fff;
        font-size: 16px;

        .head {
            padding: 0 20px;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #e5e5e5;
            background: #fff;
            position: sticky;
            top: 0;
            z-index: 2;

            .head-logo {
                flex: 0 0 117px;
                margin-bottom: -8px;

                img {
                    width: inherit;
                    height: 23px;
                    display: block;
                }
            }

            .head-btn {
                height: 24px;
                display: inline-flex;
                align-items: center;
                font-size: 16px;
                color: #e5e5e5;
                margin-right: -10px;

                button {
                    border: none;
                    background: transparent;
                    margin: 0 10px;
                    height: 24px;
                    color: #333333;

                    .link {
                        color: #333333 !important;
                    }
                }
            }
        }

        .post-content {
            padding: 10px 20px;

            h3.post-title {
                color: #333;
                font-size: 22px;
                font-weight: 900;
                line-height: 28px;
                margin-bottom: 20px;
            }

            .post-user {
                display: flex;
                align-items: center;
                margin-bottom: 20px;

                .user-portrait {
                    margin-right: 14px;
                    position: relative;
                    width: 32px;
                    height: 32px;

                    >div {
                        width: 32px;
                        height: 32px;
                        overflow: hidden;
                        border-radius: 50%;

                        img {
                            display: block;
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }

                    .bv {
                        display: block;
                        width: 16px;
                        height: 16px;
                        object-fit: cover;
                        position: absolute;
                        right: -4px;
                        bottom: -4px;
                    }
                }

                .user-info {
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;

                    .user-title {
                        max-width: 200px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        color: #000000;
                        font-weight: 600;
                        font-size: 20px;
                    }

                    img {
                        display: inline-block;
                        vertical-align: top;
                        margin-left: 6px;
                    }
                }
            }

            .issue-time {
                line-height: 30px;
                color: #999999;
                font-weight: 400;
                font-size: 14px;
                margin-top: 10px;
            }

            .content {
                img {
                    display: inline-block;
                    vertical-align: top;
                    max-width: 100%;
                    height: auto;
                }
            }
        }

        .comment-mian {
            padding: 15px 20px 0;

            .contentNum-actions {
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 56px;

                .comment-num {
                    font-size: 20px;
                    color: #333333;

                    span {
                        padding-left: 10px;
                    }
                }

                .comment-switch {
                    background: #eeeeee;
                    padding: 4px 5px;
                    height: 38px;
                    border-radius: 19px;
                    display: flex;
                    align-items: center;
                    position: relative;

                    span {
                        font-size: 16px;
                        color: #999999;
                        padding: 0 12px;
                        line-height: 30px;
                        width: 60px;
                        text-align: center;
                        cursor: pointer;
                    }

                    span.on {
                        background: #ffffff;
                        border-radius: 15px;
                        color: #333333;
                        font-weight: bold;
                        position: relative;
                        z-index: 1;
                    }

                    span.new {
                        margin-left: -10px;
                        background-repeat: no-repeat;
                        background-position: 47px center;
                        background-size: 10px 16px;
                        -webkit-filter: grayscale(.95);
                        background-image: url('~@/assets/new/icon-zx.png');
                    }

                    span.up {
                        -webkit-filter: grayscale(0);
                        background-image: url('~@/assets/new/icon-zx.png');
                    }

                    span.down {
                        -webkit-filter: grayscale(0);
                        background-image: url('~@/assets/new/icon-dx.png');
                    }
                }
            }
        }

        .comment-content-box {
            margin-top: 30px;

            ul.comment-content-list {
                li.comment-item {
                    margin-top: 20px;
                    padding-left: 37px;
                    padding-bottom: 20px;
                    position: relative;
                    border-bottom: 1px solid #e5e5e5;

                    .item-user-portrait {
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 30px;
                        height: 30px;
                        overflow: hidden;
                        border-radius: 50%;

                        img {
                            display: block;
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }

                    .item-user-info {
                        margin-bottom: 8px;
                        height: 30px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        h4 {
                            color: #333333;
                            font-size: 16px;
                            font-weight: 500;
                            display: flex;
                            align-items: center;

                            .me {
                                border: 1px solid #999999;
                                color: #999999;
                                font-size: 12px;
                                margin-left: 8px;
                                border-radius: 4px;
                                padding: 0 4px;
                                line-height: 16px;
                            }
                        }
                    }

                    .item-test,
                    .items-item-test {
                        font-size: 16px;
                        color: #666666;
                        font-weight: 400;
                        line-height: 30px;
                    }

                    .item-img-list {
                        display: flex;
                        align-items: center;

                        div.item-img-item {
                            flex: 0 0 30%;
                            height: 160px;
                            margin-right: 20px;

                            img {
                                display: block;
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                            }
                        }
                    }

                    .item-comment-box {
                        margin-top: 15px;

                        // display: flex;
                        // justify-content: space-around;
                        // align-items: flex-end;
                        .item-comment-input {
                            display: inline-block;
                            vertical-align: top;
                            width: 83.4%;

                            textarea {
                                border-radius: 10px;
                                border: 1px solid #E0E0E0;
                            }
                        }

                        .item-comment-btn {
                            display: inline-block;
                            vertical-align: bottom;
                            width: 74px;
                            height: 33px;
                            color: #ffffff;
                            border-radius: 10px;
                            font-size: 18px;
                            border: none;
                            background: #f75959;
                            margin-left: 34px;
                        }
                    }

                    .items-comment-content-box {
                        margin-top: 15px;

                        ul.items-comment-content-list {
                            background: #f9f9f9;
                            border-radius: 10px;
                            padding: 0 20px 20px;

                            li.items-comment-item {
                                border-bottom: 1px solid #e5e5e5;
                                padding-bottom: 16px;

                                .item-user-info {
                                    height: 50px;
                                    margin-bottom: 0;

                                    .items-hf {
                                        color: #333333;
                                        font-size: 16px;

                                        i {
                                            color: #999999;
                                            padding: 0 6px;
                                        }
                                    }
                                }
                            }

                            li.items-comment-item:last-child {
                                border-bottom: none;
                            }
                        }
                    }

                    .look-more {
                        display: flex;
                        align-items: center;
                        height: 16px;
                        margin-top: 20px;

                        span {
                            color: #f75959;
                            font-size: 16px;
                            cursor: pointer;
                        }
                    }
                }
            }
        }

        .new-operation-btn {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .issue-time {
                font-size: 16px;
                color: #999999;
                font-weight: 400;
            }
        }

        .operation-btn {

            .dz,
            .sc,
            .pl {
                display: inline-block;
                vertical-align: top;
                margin-left: 20px;
                color: #999999;
                font-size: 18px;
                line-height: 22px;
                padding-left: 24px;
                background-repeat: no-repeat;
                background-position: left center;
                cursor: pointer;
            }

            .dz {
                background-image: url('~@/assets/new/icon-no-praise.png');
            }

            .icon-yes-praise {
                background-image: url('~@/assets/new/icon-yes-praise.png');
            }

            .sc {
                margin-right: 20px;
                background-image: url('~@/assets/new/icon-no-collect.png');
            }

            .icon-yes-collect {
                background-image: url('~@/assets/new/icon-yes-collect.png');
            }

            .el-dropdown {
                vertical-align: top;
            }

            .pl {
                font-size: 0;
            }

            .icon-comment {
                background-image: url('~@/assets/new/icon-comment.png');
            }
        }

        .footer-open-app-text {
            height: 88px;
            display: flex;
            align-items: center;
            justify-content: center;

            button {
                background: transparent;
                color: #999999;
                font-size: 20px;
            }
        }

        .footer-open-app {
            height: 88px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #ffffff;
            position: sticky;
            bottom: 0;
            z-index: 2;

            button {
                width: 80%;
                height: 40px;
                border-radius: 20px;
                background: #f75959;
                line-height: 36px;
                font-size: 20px;
                color: #ffffff;
            }
        }
    }

    .wx-mask {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 999;
        background: url('~static/image/pointer.png');
        background-size: cover;
    }
</style>